import { AppShell, TabbarContainer } from "@app/ui";
import { ProjectsUI } from "@droid/project";
import { i18nInit, IFrameReactContainer, isDev, toProxy, watchUpdates } from "@fanfanlo";
import { Box } from "@mui/material";
import { OpenA11yNodeButton } from "@src/components/a11y/open-a11y-node-button";
import { AndroidSettingsInfo } from "@src/components/android-settings/AndroidSettingsInfo";
import { KillSelf } from "@src/components/app/kill-self/KillSelf";
import { AddExternalMarketButton } from "@src/components/markets/AddExternalMarketButton";
import { MainPageAddButtons } from "@src/components/markets/main-page-add-buttons/MainPageAddButtons";
import { MarketsDevSettingsLineOpenLinkButton } from "@src/components/page/markets-dev-settings/open-link-button/OpenLinkButton";
import { SendSms } from "@src/components/scripts/send-sms/SendSms";
import { SmsScriptItemComponent } from "@src/components/test/SmsScriptItemComponent";
import { matrix } from "@src/im/im-client/client-init";
import { marketHtmlUtils } from "@src/markets/market-html-utils";
import { marketsScriptManager } from "@src/markets/markets-script-manager";
import { useEffect, useState } from "react";
import { HomePagePermissions } from "../../components/permissions/home-page-permissions/HomePagePermissions";
import { TestScript } from "./test-script";
import { IMOpenPageLink } from "@src/im/components/page-links/PageLinks";
let count = 0

i18nInit()
export default function Home() {
   
    return (
        <AppShell>
            <TabbarContainer titleConf={{ ns: "homepage/pages/home/content", key: "home.title" }}>
                {/* {isDev ? <Content /> : <ProdContent />} */}
                <Content />
            </TabbarContainer>
        </AppShell>
    )
}


function ProdContent(){
    return (
        <Box>
            <IMOpenPageLink />
            <AndroidSettingsInfo />
            <HomePagePermissions />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
        </Box>
    )
}
function test() {
    const s = `var script1=function(n){"use strict";return function(){function v(){return new Date().getTime()}var u={exports:{}},e={};/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */var c=Symbol.for("react.transitional.element"),d=Symbol.for("react.fragment");function s(T,t,r){var i=null;if(r!==void 0&&(i=""+r),t.key!==void 0&&(i=""+t.key),"key"in t){r={};for(var o in t)o!=="key"&&(r[o]=t[o])}else r=t;return t=r.ref,{$$typeof:c,type:T,key:i,ref:t!==void 0?t:null,props:r}}e.Fragment=d,e.jsx=s,e.jsxs=s,u.exports=e;var l=u.exports;function a(){return l.jsx("div",{children:l.jsx("button",{children:"html生成的按钮"})})}const x={UI:a};function E(){return v()}n.components=x,n.printA=E,Object.defineProperty(n,Symbol.toStringTag,{value:"Module"})}(),n}({}); return script1;`
    const o = new Function(s)()
    o.printA();
    // console.log('cccccccccccccccomponents=', o.components)
    return o;
}


function testWatchUpdates(){
    const data = toProxy({
        name:'a',
        friend:{
            name:'b',
            fav:{
                food:"c"
            }
        }
    })
    console.log('data =', data);
    watchUpdates(data, (info)=>{
        console.log('testWatchUpdates_fn watchUpdates', info)
    })
    data.name = 'c'
    data.friend.name = 'd'
    data.friend.fav.food = 'e'
}
// export const XXX = Home
function Content() {
    // const o = test();
    // const ui = o.components.UI();
    // console.log('ffffffffffffff',ui)
    const [ui, setUI] = useState(null)
    useEffect(() => {
        if (typeof window !== 'undefined') {
            // console.log('has window', document.domain);
            // document.domain = window.location.hostname;
            // console.log('domain is', document.domain);
            ; (window as any).sayHello = function (msg: string) {
                alert('child' + msg)
            }
            console.log('window say=', (window as any).sayHello)
        }
        setTimeout(() => {
            setUI(test().components.UI())
        }, 1000 * 5)
    }, [])

    useEffect(() => {
        marketsScriptManager.init();
    }, []);
    console.log('isDev=', isDev);
    return (
        <Box >
            {/* <ProjectIFrame /> */}
            
            <IMOpenPageLink />
            <SendSms />
            <AndroidSettingsInfo />
            <SmsScriptItemComponent />
            <AddExternalMarketButton />
            {/* {o.components.UI()} */}
            {ui}
            <HomePagePermissions />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            {/* <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} />
            <IFrameReactContainer url="/scripts/fanfanlo/scripts/emergency-alarm/index.js" urlAsContent={true} htmlBuilder={marketHtmlUtils.createHtml} /> */}

            {/* <IframeResizer offsetSize={3} bodyMargin="0px" bodyPadding="0px" style={{width:'100%'}}
            src="http://192.168.177.180:3000/tools-test/webview-version.html" /> */}

            {/* <IframeResizer offsetSize={3} bodyMargin="0px" bodyPadding="0px" style={{width:'100%'}}
            src="https://baidu.com" /> */}
            <Box>
                <OpenA11yNodeButton />
            </Box>
            <TestScript />
            <Box>
                <KillSelf />
            </Box>
            <MarketsDevSettingsLineOpenLinkButton />    
            <MainPageAddButtons />
            {/* <IFrameReactContainer url="http://192.168.177.180:5173/pages/accessibility-pn-an-info/#" /> */}
            {/* <IFrameReactContainer url="http://192.168.177.180:5173/pages/market1/" /> */}
            <ProjectsUI />

            {/* <div>isInAndroid:{isInAndroid().toString()}</div>
            <div>count:{count}</div> */}
            <div>
            </div>
        </Box>

    )
}

